import React from "react";
import { fmtMonth } from "@/lib/format";

// Builds year + month option lists from data start (2023) to current month.
const CURRENT_YEAR = new Date().getFullYear();
const YEARS = [];
for (let y = CURRENT_YEAR; y >= 2023; y--) YEARS.push(String(y));

const MONTHS = [];
(() => {
  const now = new Date();
  let y = now.getFullYear();
  let m = now.getMonth() + 1;
  while (y > 2023 || (y === 2023 && m >= 1)) {
    MONTHS.push(`${y}-${String(m).padStart(2, "0")}`);
    m -= 1;
    if (m === 0) { m = 12; y -= 1; }
    if (y < 2023) break;
  }
})();

export function periodLabel(period, value) {
  switch (period) {
    case "last7": return "Last 7 days";
    case "last30": return "Last 30 days";
    case "month": return value ? fmtMonth(value) : "Month";
    case "year": return value || "Year";
    default: return "All time";
  }
}

// Returns axios params object for a given period selection.
export function periodParams(period, value) {
  const p = { period };
  if ((period === "month" || period === "year") && value) p.value = value;
  return p;
}

// Returns a query string (?period=..&value=..) for navigation links.
export function periodQuery(period, value) {
  const sp = new URLSearchParams({ period });
  if ((period === "month" || period === "year") && value) sp.set("value", value);
  return `?${sp.toString()}`;
}

const BTN = "px-3 py-1.5 rounded text-sm font-medium transition-colors";

export function PeriodSelector({ period, value, onChange, testid = "period-selector", hideQuick = false }) {
  const isMonth = period === "month";
  const isYear = period === "year";

  return (
    <div className="inline-flex items-center gap-2 flex-wrap" data-testid={testid}>
      {!hideQuick && (
        <div className="inline-flex items-center gap-1 bg-slate-100 rounded-md p-1">
          <button data-testid="period-all" onClick={() => onChange("all", null)}
            className={`${BTN} ${period === "all" ? "bg-white shadow-sm text-slate-900" : "text-slate-500 hover:text-slate-800"}`}>All</button>
          <button data-testid="period-last7" onClick={() => onChange("last7", null)}
            className={`${BTN} ${period === "last7" ? "bg-white shadow-sm text-slate-900" : "text-slate-500 hover:text-slate-800"}`}>Last 7 days</button>
          <button data-testid="period-last30" onClick={() => onChange("last30", null)}
            className={`${BTN} ${period === "last30" ? "bg-white shadow-sm text-slate-900" : "text-slate-500 hover:text-slate-800"}`}>Last 30 days</button>
        </div>
      )}

      <select
        data-testid="period-month-select"
        value={isMonth && value ? value : ""}
        onChange={(e) => onChange("month", e.target.value)}
        className={`px-3 py-1.5 rounded-md border text-sm font-medium outline-none focus:ring-2 focus:ring-slate-900 cursor-pointer ${
          isMonth ? "border-slate-900 bg-white text-slate-900" : "border-slate-300 bg-white text-slate-500"
        }`}
      >
        <option value="" disabled>Month…</option>
        {MONTHS.map((ym) => <option key={ym} value={ym}>{fmtMonth(ym)}</option>)}
      </select>

      <select
        data-testid="period-year-select"
        value={isYear && value ? value : ""}
        onChange={(e) => onChange("year", e.target.value)}
        className={`px-3 py-1.5 rounded-md border text-sm font-medium outline-none focus:ring-2 focus:ring-slate-900 cursor-pointer ${
          isYear ? "border-slate-900 bg-white text-slate-900" : "border-slate-300 bg-white text-slate-500"
        }`}
      >
        <option value="" disabled>Year…</option>
        {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
}
